var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEvaluation03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 96,
    viewBox: "0 0 95 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1410_45881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0472 78.8113C59.851 78.8113 75.0945 63.5678 75.0945 44.764C75.0945 25.9603 59.851 10.7168 41.0472 10.7168C22.2435 10.7168 7 25.9603 7 44.764C7 63.5678 22.2435 78.8113 41.0472 78.8113Z",
    fill: "#F2F3F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1410_45881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7218 25.9375H35.0608V67.8208H84.7218V25.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7218 69.3315H35.0609C34.212 69.3315 33.5205 68.6536 33.5205 67.8213V25.938C33.5205 25.1057 34.212 24.4277 35.0609 24.4277H84.7218C85.5707 24.4277 86.2622 25.1057 86.2622 25.938V67.8213C86.2622 68.6536 85.5707 69.3315 84.7218 69.3315ZM36.6012 66.3111H83.1815V27.4482H36.6012V66.3111Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4596 24.6296C88.4596 26.509 86.9055 28.0326 84.9886 28.0326H34.7937C32.8768 28.0326 31.3228 26.509 31.3228 24.6296C31.3228 22.7502 32.8768 21.2266 34.7937 21.2266H84.9886C86.9055 21.2266 88.4596 22.7502 88.4596 24.6296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9887 29.5433H34.7938C32.028 29.5433 29.7825 27.3417 29.7825 24.63C29.7825 21.9184 32.0348 19.7168 34.7938 19.7168H84.9887C87.7545 19.7168 90 21.9184 90 24.63C90 27.3417 87.7545 29.5433 84.9887 29.5433ZM34.7938 22.7372C33.7258 22.7372 32.8632 23.583 32.8632 24.63C32.8632 25.6771 33.7326 26.5228 34.7938 26.5228H84.9887C86.0567 26.5228 86.9193 25.6704 86.9193 24.63C86.9193 23.5897 86.0499 22.7372 84.9887 22.7372H34.7938Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0595 53.1621H45.6516V60.4917H52.0595V53.1621Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0954 46.5312H56.6875V60.4924H63.0954V46.5312Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.131 34.6641H67.7231V60.4921H74.131V34.6641Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8689 62.0029H41.9136C41.0647 62.0029 40.3733 61.3249 40.3733 60.4926C40.3733 59.6603 41.0647 58.9824 41.9136 58.9824H77.8689C78.7178 58.9824 79.4093 59.6603 79.4093 60.4926C79.4093 61.3249 78.7178 62.0029 77.8689 62.0029Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9253 66.8164H28.112C23.9291 66.8164 20.5403 70.1389 20.5403 74.24V83.7308C25.442 85.3082 31.0558 86.2009 37.0186 86.2009C42.9815 86.2009 48.5952 85.3082 53.497 83.7308V74.24C53.497 70.1389 50.1082 66.8164 45.9253 66.8164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0187 87.7174C31.1038 87.7174 25.2367 86.8381 20.0611 85.1735C19.4313 84.9722 19 84.3882 19 83.7371V74.2463C19 69.3196 23.0871 65.3125 28.112 65.3125H45.9185C50.9435 65.3125 55.0306 69.3196 55.0306 74.2463V83.7371C55.0306 84.3882 54.6061 84.9654 53.9694 85.1735C48.787 86.8381 42.9268 87.7174 37.0119 87.7174H37.0187ZM22.0807 82.6296C26.6881 83.9855 31.8294 84.697 37.0187 84.697C42.208 84.697 47.3493 83.9855 51.9567 82.6296V74.2463C51.9567 70.9842 49.2525 68.3329 45.9254 68.3329H28.112C24.7849 68.3329 22.0807 70.9842 22.0807 74.2463V82.6296Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8861 85.5087C27.0372 85.5087 26.3457 84.8308 26.3457 83.9985V77.7563C26.3457 76.924 27.0372 76.2461 27.8861 76.2461C28.735 76.2461 29.4264 76.924 29.4264 77.7563V83.9985C29.4264 84.8308 28.735 85.5087 27.8861 85.5087Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1512 85.5087C45.3023 85.5087 44.6108 84.8308 44.6108 83.9985V77.7563C44.6108 76.924 45.3023 76.2461 46.1512 76.2461C47.0001 76.2461 47.6915 76.924 47.6915 77.7563V83.9985C47.6915 84.8308 47.0001 85.5087 46.1512 85.5087Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6798 56.109C43.6798 52.4979 40.6949 49.5781 37.0186 49.5781C33.3423 49.5781 30.3506 52.5046 30.3506 56.109C30.3506 59.7134 33.3354 62.6465 37.0186 62.6465C40.7018 62.6465 43.6798 59.7201 43.6798 56.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0187 64.1572C32.4935 64.1572 28.8103 60.5461 28.8103 56.1094C28.8103 51.6727 32.4935 48.0684 37.0187 48.0684C41.5439 48.0684 45.2202 51.6795 45.2202 56.1094C45.2202 60.5394 41.537 64.1572 37.0187 64.1572ZM37.0187 51.0821C34.1913 51.0821 31.891 53.3373 31.891 56.1027C31.891 58.8681 34.1913 61.1301 37.0187 61.1301C39.8461 61.1301 42.1395 58.8748 42.1395 56.1027C42.1395 53.3306 39.8392 51.0821 37.0187 51.0821Z",
    fill: "#B3B8C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1410_45881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 74.7135,
    fill: "white",
    transform: "translate(7 10.7168)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1410_45881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 68,
    fill: "white",
    transform: "translate(19 19.7168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvaluation03);
export default __webpack_public_path__ + "static/media/icon_evaluation03.1c6f931efbfa7f3e9ca8ea08e9735e08.svg";
export { ForwardRef as ReactComponent };